export const formatCompanyPayload = (endPoint, payload) => {
  let url = `${endPoint}?isHidden.equals=false&sort=revenue.id,desc&sort=id,asc&page=${payload?.page ? payload?.page : 0}&size=${payload?.size ? payload?.size : 10}`;
  if (payload?.Countries) {
    url = `${url}&country.in=${payload?.Countries}`;
  }
  if (payload?.States) {
    url = `${url}&state.in=${payload?.States}`;
  }
  if (payload?.Cities) {
    url = `${url}&city.in=${payload?.Cities}`;
  }
  if (payload?.Industry) {
    url = `${url}&industryId.in=${payload?.Industry}`;
  }
  if (payload?.["Company Type"]) {
    url = `${url}&categoryId.in=${payload?.["Company Type"]}`;
  }
  if (payload?.["Employee Count"]) {
    url = `${url}&rangeId.in=${payload?.["Employee Count"]}`;
  }
  if (payload?.["Revenue Range"]) {
    url = `${url}&revenueId.in=${payload?.["Revenue Range"]}`;
  }
  if (payload?.searchKeyword) {
    url = `${url}&productServices.contains=${payload?.searchKeyword}`;
  }
  if (payload?.Name) {
    url = `${url}&name.contains=${payload?.Name}`;
  }
  if (payload?.Tags) {
    url = `${url}&tags=${payload?.Tags}`;
  }
  return url;
};
